<template>
    <div class="container4">
        <div class="title">
            <p>百家大讲堂</p>
            <el-button type="primary" round @click="handleSchool">
                更多<i class="el-icon-arrow-right"></i>
        </el-button>
        </div>
       
        <div class="main-box4">
            <div class="nav4">
                <p slot="reference" class="slotPoper" @click="handleListVideo(1)" :class="active==1?'slotPoperColor':''">视频</p>
                <p slot="reference" class="slotPoper" @click="handleListVideo(2)" :class="active==2?'slotPoperColor':''">直播</p>
                <p slot="reference" class="slotPoper" @click="handleListVideo(3)" :class="active==3?'slotPoperColor':''">课件</p>
                
            </div>
            <div class="main4">
                <div class="videoListBox">
                    <div v-for="item in videoList" :key="item.id" >
                        <div class="videoContent-div" >
                            <div style="height: 150px;">
                                    <videoPlayer :mp4Url="item.file_url" :mp4Pic="item.firstFile.FileUrl" v-show="active==1"></videoPlayer>
                                    <div @click="getVideoInfo(item)" v-show="active!=1">
                                        <img :src="item.firstFile.FileUrl" style="width: 280px;height: 200px; object-fit: cover;" alt="">
                                    </div>
                            </div>
                            <div @click="getVideoInfo(item)">
                                <p :class="active == 1? 'videoTitle': 'coursewareTitle'">{{ item.name }}</p>
                                <p class="cate-context" v-show="active==1">
                                    {{ item.cate_name }}
                                    <span>|</span>
                                    观看次数{{ item.click_amount }}
                                </p>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
import videoPlayer from '../video/videoPlayer.vue'
export default{
    data(){
        return{
            active: 1,
            videoList: []
        }
    },
    components:{
        videoPlayer
    },
    methods: {
        handleSchool(){
            this.$router.push({
                path: '/school'
            })
        },
        getVideoList(data){
            this.videoList = []
            this.$store.dispatch('video/listvideo',data)
                .then(res => {
                    console.log(res);
                    if(res.ok){
                        this.videoList = res.data.items
                        
                    }
                })
        },
        getVideoInfo(item){
            console.log("aidfjdfldjf-----");
            console.log(item);

            if(this.active == 1){
                
                const { href } = this.$router.resolve({
                    path: "/videoDetail",
                    query: {
                        key: item.id,
                        currentName: '视频详情'
                    }
                });
            window.open(href, '_blank');
            }else if(this.active == 3){
               
                const { href } = this.$router.resolve({
                    path: "/courseware",
                    query: {
                        key: item.id
                    }
                });
            window.open(href, '_blank');
            }else if(this.active == 2){
                
                const { href } = this.$router.resolve({
                    path: "/listlive",
                    query: {
                        key: item.id,
                    }
                });
                window.open(href, '_blank');
            }
        },
        handleListVideo(val){
            this.active = val
            let data = {
                pageNum: 1,
                pageSize: 3,
                cate: '',
                keywords: '',
            }
            this.videoList = []
            if(val == 1){
                this.getVideoList(data)
            }else if(val == 2){
                this.$store.dispatch('video/listlive',data)
                    .then(res => {
                        if(res.ok){
                            this.videoList = res.data.items
                        }
                    })
            }else if(val == 3){
                this.$store.dispatch('video/listcourse',data)
                    .then(res => {
                        if(res.ok){
                            this.videoList = res.data.items
                        }
                    })
            }
        }
        
    },
    mounted(){
        let data = {
            pageNum: 1,
            pageSize: 3,
            cate: '',
            keywords: '',
        }
        this.getVideoList(data)
    },
}
</script>
<style scoped>
.container4{
    width: 1180px;
    margin-top: 20px;
    padding: 10px 10px;
    background: #fff;
}

.container4 .title{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.5px solid #f2f2f2;
  border-radius: 5px;
  /* background: rgb(209, 223, 250,0.4); */
}
.container4 .title p{
  font-size: 22px;
  font-weight: 700;
  /* background: rgb(187, 208, 247);    */
  padding: 15px 15px;
  border-radius: 15px;
  margin-right: 60px;
}
.container4 .title span{
  cursor: pointer;
  font-size: 16px;
}
.container4 .title span:hover{
  color: #00a8a8;
}


.main-box4 .main4{
  width: 950px;
  margin-top: 5px;
  /* border-radius: 10px; */
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  overflow: hidden;
}

.slotPoper{
  padding: 10px 10px;
  width: 180px;
  line-height: 36px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  background: #F5F7F9;
}
.slotPoper:hover{
  background: rgb(0, 168, 168, 0.1);
}
.slotPoperColor{
  color: #008a8a;
  background: rgb(0, 168, 168, 0.1);
}





.videoListBox::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.videoListBox::-webkit-scrollbar-track {
  background-color:transparent;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius:2em;
}
.videoListBox::-webkit-scrollbar-thumb {
  background-color: rgb(147,147,153,0.5);
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius:2em;
}

.videoContent-div{
    width: 280px;height: 300px;
    margin:5px 40px 5px 0;
    border: 1px solid #f2f2f2;
    border-radius: 10px;
    cursor: pointer;
} 
.videoTitle{
    font-size: 16px;
    margin-top: 15px;
    height: 70px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    padding: 5px 10px 5px 10px;
}
.coursewareTitle{
    font-size: 16px;
    margin-top: 60px;
    height: 70px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    padding: 5px 10px 5px 10px;
}
.cate-context{
    font-size: 13px;
    margin-top: 20px;
    color: #999999;
    text-align: center;
    cursor: pointer;
}

@media screen and (min-width: 541px) {
    
    .main-box4{
        display: flex;
        justify-content: space-between;
    }
    .main-box4 .nav4{
        width: 200px;
        padding: 10px 0 10px 0;
        text-align: center;
        margin-top: 10px;
    
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
    }
    .videoListBox{
        width: 950px;
        min-height: 320px;
        margin-top: 10px;
        display: flex;
        justify-content: flex-start;
        /* overflow-x: scroll; */

    }
}
@media screen and (max-width: 540px) {
    .container4{
        width: 100%;
        padding: 0 0;
    }

    .container4 .title p{
        font-size: 18px;
        padding: 15px 5px;
    }

    .main-box4 .nav4{
        
        padding: 10px  10px ;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
        margin-top: 10px;
    }
    .slotPoper{
        padding: 10px 20px;
        width: 210px;
        line-height: 36px;
        text-align: center;
        font-size: 18px;
        cursor: pointer;
        background: #F5F7F9;
    }
    .main-box4 .main4{
        width: 99%;
        margin: 5px auto;
    }
    .videoListBox{
        width: 98%;
        margin: 10px auto;
        min-height: 320px;
        /* overflow-x: scroll; */

    }

    .videoContent-div{
        width: 97%;height: 300px;
        margin: 5px auto;
        margin-bottom: 30px;
        /* margin:5px 40px 20px 0; */
        border: 1px solid #f2f2f2;
        border-radius: 10px;
        cursor: pointer;
    } 

    .videoTitle{
        margin-top: 55px;
        height: 50px;
    }
    .coursewareTitle{
        margin-top: 70px;
    }
    .cate-context{
        font-size: 13px;
        margin-top: 10px;
        color: #999999;
        text-align: center;
        cursor: pointer;
    }
}
</style>